var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftwareDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.6L5 7.8L12 5L19 7.8L12 10.6Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27854 15.5036C4.89396 15.3498 4.45748 15.5369 4.30364 15.9215C4.14981 16.306 4.33687 16.7425 4.72146 16.8964L5.27854 15.5036ZM12 19L11.7215 19.6964C11.9003 19.7679 12.0997 19.7679 12.2785 19.6964L12 19ZM19.2785 16.8964C19.6631 16.7425 19.8502 16.306 19.6964 15.9215C19.5425 15.5369 19.106 15.3498 18.7215 15.5036L19.2785 16.8964ZM5.27854 11.3036C4.89396 11.1498 4.45748 11.3369 4.30364 11.7215C4.14981 12.106 4.33687 12.5425 4.72146 12.6964L5.27854 11.3036ZM12 14.8L11.7215 15.4964C11.9003 15.5679 12.0997 15.5679 12.2785 15.4964L12 14.8ZM19.2785 12.6964C19.6631 12.5425 19.8502 12.106 19.6964 11.7215C19.5425 11.3369 19.106 11.1498 18.7215 11.3036L19.2785 12.6964ZM4.72146 16.8964L11.7215 19.6964L12.2785 18.3036L5.27854 15.5036L4.72146 16.8964ZM12.2785 19.6964L19.2785 16.8964L18.7215 15.5036L11.7215 18.3036L12.2785 19.6964ZM4.72146 12.6964L11.7215 15.4964L12.2785 14.1036L5.27854 11.3036L4.72146 12.6964ZM12.2785 15.4964L19.2785 12.6964L18.7215 11.3036L11.7215 14.1036L12.2785 15.4964Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDesign);
export default __webpack_public_path__ + "static/media/softwareDesign.e5b7679d02bfdd549e917ed48c58d569.svg";
export { ForwardRef as ReactComponent };